<div mat-dialog-title>
    <mat-label>{{'FORM.huntingDistrictForm.jabSignature' | translate}}</mat-label>
</div>
<mat-dialog-content>
    <section style="align-items: center;">
    
        <div >
            <canvas class="border w-100" #signPadCanvas id="signaturePad" ></canvas>
        </div>
    
        <button mat-button type="button" (click)="onUndo()" color="warn">{{'FORM.huntingDistrictForm.undo' | translate}}</button> 
        <button mat-button type="button" (click)="onClear()">{{'FORM.huntingDistrictForm.clear' | translate}}</button>
        
    </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
    
    <div style="display:flex; flex-direction: row;">
        <button class="spanw" mat-raised-button type="button" (click)="onCancle()" color="#000" class="second-btn" style="padding: 0;">{{'filter_date_range_items.cancel' | translate}}</button> 
        <button class="spanw" mat-raised-button type="button" (click)="onSave()" class="first-btn">{{'FORM.huntingDistrictForm.addSignature' | translate}}</button>
    </div>
</mat-dialog-actions>